module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.c7debbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_lets-get_768.png
// module id = 4RYg
// module chunks = 0